import { render, staticRenderFns } from "./CrupierScreen.vue?vue&type=template&id=4311dd53&"
import script from "./CrupierScreen.vue?vue&type=script&lang=js&"
export * from "./CrupierScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports